// extracted by mini-css-extract-plugin
module.exports = {"description":"_TBsT7AMJPIaquGg8Y_Q6"};